import { AxiosRequestConfig } from 'axios';
import educationServices from '../services/educationServices';
import { Education, EducationRequest } from '../@types/educationTypes';

export async function fetchPaginatedEducations(config: AxiosRequestConfig) {
  const response = await educationServices.getEducations(config);
  return response;
}

export async function fetchEducationById(id: string) {
  const response = await educationServices.getEducationById(id);
  return response;
}

export async function fetchEducationsTileKey(config: AxiosRequestConfig) {
  config.params = {
    ...config.params,
    tileKey: true
  };
  const response = await educationServices.getEducations(config);
  return response;
}

export async function deleteEducationById(id: string) {
  const response = await educationServices.deleteEducationById(id);
  return response;
}

export async function createEducation(educationData: EducationRequest) {
  const response = await educationServices.createEducation(educationData);
  return response;
}

export async function updateEducation(id: string, updatedEducationData: EducationRequest) {
  const response = await educationServices.updateEducation(id, updatedEducationData);
  return response;
}

export async function getEducationInformationChartData(config: AxiosRequestConfig) {
  const response = await educationServices.getEducationInformationChartData(config);
  return response;
}